import EnvironmentService from "./environmentService";
import { IItemIdentifier } from "@wbmason/my-list-service";
import { WBMUrlService } from "@wbmason/url-service";
import { BaseHostUrlService } from "../utilities/baseHostUrlService";

const addSRQtoURL = (url: string): string => {
  const queryParams = window.location.search
    .substring(1)
    .replaceAll("&", "%26");

  if (queryParams) {
    return `${url}&srq=${queryParams}`;
  } else {
    return url;
  }
};

export const productUrlService = {
  getItemHref(
    itemIdentifier: IItemIdentifier,
    enableResponsiveSearchResults: boolean | null,
    icid?: string | null
  ): string {
    let returnUrl = "";

    if (enableResponsiveSearchResults) {
      const pdpUrl = WBMUrlService.getPDPUrl(
        BaseHostUrlService.get(),
        EnvironmentService.get().ecomPDP
      );

      returnUrl = `${pdpUrl}${itemIdentifier.id}?uom=${itemIdentifier.unitId}&COID=${itemIdentifier.couponOfferCode}`;
    } else {
      const ecomUrl = WBMUrlService.getEcomUrl(
        BaseHostUrlService.get(),
        EnvironmentService.get().ecom
      );

      returnUrl = `${ecomUrl}${
        EnvironmentService.get().ecomProductDetail
      }?ItemID=${itemIdentifier.id}&uom=${itemIdentifier.unitId}&COID=${
        itemIdentifier.couponOfferCode
      }`;
    }
    if (icid) {
      returnUrl += `&icid=${icid}`;
    }
    if (
      typeof window !== "undefined" &&
      window.location &&
      (window.location.href.includes("/shop?") ||
        window.location.href.includes("/shop/"))
    ) {
      returnUrl = addSRQtoURL(returnUrl);
    }
    return returnUrl;
  },
};
